import { Component, OnInit, Input } from '@angular/core';
import { ParishScreenHandler } from 'src/app/handlers/ParishScreenHandler';
import screen from '../../../../assets/ParishScreen.json';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-parish-detail',
  templateUrl: './parish-detail.component.html',
  styleUrls: ['./parish-detail.component.scss']
})
export class ParishDetailComponent implements OnInit {

  public screenStructure = JSON.parse(JSON.stringify(screen));

  @Input() uid: string;

  constructor(private route: ActivatedRoute, public screenHandler: ParishScreenHandler) { }

  ngOnInit() {
    this.uid = this.route.snapshot.paramMap.get('id');
  }


}
